import React from 'react';
import { Snackbar, Alert, AlertColor, IconButton } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';

export interface ToastMessage {
  id: string;
  message: string;
  severity?: AlertColor;
  duration?: number;
}

interface SuccessToastProps {
  open: boolean;
  message: string;
  onClose: () => void;
  severity?: AlertColor;
  duration?: number;
}

export const SuccessToast: React.FC<SuccessToastProps> = ({
  open,
  message,
  onClose,
  severity = 'success',
  duration = 4000,
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      sx={{
        '& .MuiSnackbar-root': {
          bottom: '24px !important',
        },
        // Celular: no rodapé o toast cobriria as barras de ação fixas dos formulários.
        // Fica no topo, abaixo do header + abas (APP_HEADER 48px + TAB_BAR 44px).
        top: { xs: 'calc(104px + env(safe-area-inset-top, 0px))', sm: 'auto' },
        bottom: { xs: 'auto', sm: '24px' },
      }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant="filled"
        icon={<CheckCircleIcon />}
        sx={{
          minWidth: { xs: 0, sm: '300px' },
          width: { xs: '100%', sm: 'auto' },
          '& .MuiAlert-icon': {
            fontSize: '1.5rem',
          },
          '& .MuiAlert-message': {
            fontSize: '0.95rem',
            fontWeight: 500,
          },
        }}
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={onClose}
            sx={{ ml: 1 }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

